import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'app-circle-warning',
	standalone: false,
	templateUrl: './circle-warning.component.html',
	styleUrl: './circle-warning.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class CircleWarningComponent {}
